export default __webpack_public_path__ + "static/media/logo.d2472c2e.svg";